import React, { useState, useEffect, useRef} from "react";
import { Box, Button, Card, CardContent, CardMedia, Dialog, DialogContent, DialogTitle, DialogActions,
  Grid, Typography, Tabs, Tab, Container, Divider, IconButton, Rating, TextField
} from "@mui/material";
import RestaurantMenuIcon from "@mui/icons-material/RestaurantMenu";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { db } from "../../firebase";
import { collection, getDocs, query, where, doc, getDoc, updateDoc } from "firebase/firestore";
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useNavigate, useSearchParams  } from 'react-router-dom';
import Cart from './Cart';
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

const CATEGORIES = ["Starters", "Main Course", "Beverages", "Desserts", "Others", "All"];

export default function ViewMenu({ cart = [], setCart, companyCode, companyName, tableId, unitCode, updateCartInFirestore, serviceArea,
toggleCartDrawer, openCartDrawer,
  openCart
 }) {
  console.log(`ViewMenu Props top:`, { cart, setCart: typeof setCart, companyCode, companyName, tableId, unitCode, updateCartInFirestore: typeof updateCartInFirestore, serviceArea, toggleCartDrawer: typeof toggleCartDrawer, openCartDrawer, openCart: typeof openCart });
  const [items, setItems] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  //const [activeTab, setActiveTab] = useState(0);
  const [activeCategory, setActiveCategory] = useState("All");
  const [localSearchQuery, setLocalSearchQuery] = useState('');
  const [detailDialog, setDetailDialog] = useState({ open: false, item: null });
  const [cartMarginAdjustment, setCartMarginAdjustment] = useState(0);
  //const [openCartDrawer, setOpenCartDrawer] = useState(false);
  const [isPureVeg, setIsPureVeg] = useState(null);
  const [cookingInstructions, setCookingInstructions] = useState({});
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const navigate = useNavigate();
const [searchParams] = useSearchParams();
const [categories, setCategories] = useState([]);
const [categoryImages, setCategoryImages] = useState({});
const menuItemsRef = useRef(null);
const categoriesRef = useRef(null);
const [showScrollTop, setShowScrollTop] = useState(false);
const [billingPreference, setBillingPreference] = useState(2); // default allow
const [menuTimings, setMenuTimings] = useState([]);
const isViewOnly = billingPreference === 0 || billingPreference === 1;
//const service = searchParams.get('service');
const service =
  searchParams.get('service') ||
  searchParams.get('serviceArea');
const cartId = searchParams.get('cartId');
  /*const toggleCartDrawer = () => {
    console.log(`ViewMenu: Toggling cart drawer, current state: ${openCartDrawer}`);
   setOpenCartDrawer(true);
  };*/

  console.log(`view menu recieved data: openCartDrawer: ${openCartDrawer}, openCart function: ${typeof openCart === 'function'}, toggleCartDrawer function: ${typeof toggleCartDrawer === 'function'}`);

  useEffect(() => {
    const drawerWidth = isMobile ? 0 : 300;
    const newMargin = openCartDrawer ? drawerWidth : 10;
    console.log(`ViewMenu: Updating cartMarginAdjustment to ${newMargin}px, openCartDrawer: ${openCartDrawer}, isMobile: ${isMobile}`);
    setCartMarginAdjustment(newMargin);
  }, [openCartDrawer, isMobile]);

  console.log('ViewMenu Props:', { cart, setCart: typeof setCart, companyCode, companyName, tableId, unitCode, openCartDrawer, isMobile });

  const fetchUnitDetails = async () => {
    try {
      const unitDocRef = doc(db, "units", unitCode);
      const unitDoc = await getDoc(unitDocRef);
      if (unitDoc.exists()) {
        const unitData = unitDoc.data();
        console.log(`ViewMenu: Fetched unit details for ${unitCode}:`, unitData);
        setIsPureVeg(unitData.isPureVeg || false);
      } else {
        console.warn(`ViewMenu: No unit document found for ${unitCode}`);
        setIsPureVeg(false);
      }
    } catch (error) {
      console.error(`ViewMenu: Error fetching unit details for ${unitCode}:`, error);
      setIsPureVeg(false);
    }
  };

  useEffect(() => {
  const fetchBillingPreference = async () => {
    if (!companyCode || !unitCode) return;

     try {
      const q = query(
        collection(db, "preferences"),
        where("companyCode", "==", companyCode),
        where("unitCode", "==", unitCode),
        where("preferenceName", "==", "Billing Process")
      );

      const snapshot = await getDocs(q);

      if (!snapshot.empty) {
        const data = snapshot.docs[0].data();
        setBillingPreference(Number(data.preferenceValue));
      } else {
        setBillingPreference(2); // fallback
      }

    } catch (error) {
      console.error("Billing preference error:", error);
      setBillingPreference(2); 
    }
  };

  fetchBillingPreference();
}, [companyCode, unitCode]);

const fetchMenuTimings = async () => {
  try {
    const q = query(
      collection(db, "preferences"),
      where("companyCode", "==", companyCode),
      where("unitCode", "==", unitCode),
      where("preferenceType", "==", "Menu Timing")
    );

    const snapshot = await getDocs(q);

    const timings = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));

    setMenuTimings(timings);
  } catch (err) {
    console.error("Error fetching menu timings:", err);
  }
};

  const fetchItems = async () => {
    if (!companyCode || !unitCode) {
      setError("Company code or unit code is missing.");
      //setIsLoading(false);
      return;
    }
    try {
      setIsLoading(true);
      setError(null);
      const q = query(
        collection(db, "companymenu"),
        where("companyCode", "==", companyCode),
        where("unitCode", "==", unitCode)
      );
      const snapshot = await getDocs(q);
      const data = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      console.log(`ViewMenu: Fetched ${data.length} menu items for companyCode: ${companyCode}, unitCode: ${unitCode}`);
      setItems(data.map(item => ({
        ...item,
        averageRating: item.averageRating !== undefined ? item.averageRating : 4 // Default to 4 if not present
      })));
      if (data.length === 0) {
        setError(`No menu items found for ${companyName || companyCode} at unit ${unitCode}.`);
      }
    } catch (error) {
      console.error(`ViewMenu: Error fetching menu items for companyCode ${companyCode}, unitCode ${unitCode}:`, error);
      setError(`Failed to load menu items for ${companyName || companyCode} at unit ${unitCode}. Please try again.`);
    } finally {
      setIsLoading(false);
    }
  };

  const [priceCategory, setPriceCategory] = useState(null);

  const fetchCategories = async () => {
  try {
    const q = query(
      collection(db, "categories"),
      where("companyCode", "==", companyCode),
      where("unitCode", "==", unitCode)
    );

    const snapshot = await getDocs(q);

    let data = snapshot.docs.map(doc => doc.data().name);

    // Optional: ensure "All" is always there
    data = ["All", ...data];

    console.log("Categories fetched:", data);

    setCategories(data);

    // Set default category if not set
    if (data.length > 0) {
      setActiveCategory(data[0]);
    }

  } catch (error) {
    console.error("Error fetching categories:", error);
  }
};

useEffect(() => {
  if (!items.length) return;

  const map = {};

  items.forEach(item => {
    if (item.category && item.imageUrl && !map[item.category]) {
      map[item.category] = item.imageUrl; 
    }
  });

  console.log("Category Images:", map);

  setCategoryImages(map);
}, [items]);
const fetchServiceArea = async () => {
  try {
    if (!service) return;

    const docRef = doc(db, "serviceAreas", service);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      const data = docSnap.data();
      console.log("Service Area:", data);

      setPriceCategory(data.priceCategory);
    } else {
      console.warn("No matching service area found");
    }

  } catch (err) {
    console.error("Error fetching service area:", err);
  }
};

/*useEffect(() => {
  const fetchData = async () => {
    await fetchUnitDetails();
    await fetchItems();
    await fetchServiceArea(); 
    await fetchCategories();
  };
  fetchData();
}, [companyCode, unitCode, service]);*/

useEffect(() => {
  const fetchData = async () => {
    setIsLoading(true);

    await Promise.all([
      fetchUnitDetails(),
      fetchItems(),
      fetchServiceArea(),
      fetchCategories(),
      fetchMenuTimings(),
    ]);

    setIsLoading(false);
  };

  fetchData();
}, [companyCode, unitCode, service]);

const toMinutes = (t) => {
  const [h, m] = t.split(":").map(Number);
  return h * 60 + m;
};

const getActiveTimings = () => {
  const now = new Date();
  const current = now.getHours() * 60 + now.getMinutes();

  return menuTimings
    .filter(t => {
      const from = t.preferenceValue?.from;
      const to = t.preferenceValue?.to;

      if (!from || !to) return false;

      const fromMin = toMinutes(from);
      const toMin = toMinutes(to);

      return current >= fromMin && current <= toMin;
    })
    .map(t => t.preferenceName);
};

const getItemPrice = (item) => {
  if (priceCategory && item.categoryPrices) {
    const servicePrice = item.categoryPrices[priceCategory];

    if (servicePrice) {
      return parseFloat(servicePrice);
    }
  }

  return item.basePrice || item.price || 0;
};

  /*useEffect(() => {
    let isMounted = true;
    const fetchData = async () => {
      await fetchUnitDetails();
      await fetchItems();
    };
    fetchData().then(() => {
      if (!isMounted) return;
    });
    return () => {
      isMounted = false;
    };
  }, [companyCode, unitCode]);*/

  /*const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
    setLocalSearchQuery('');
  };*/

  const handleCategoryChange = (category) => {
    setActiveCategory(category);
    setLocalSearchQuery('');

    setTimeout(() => {
    menuItemsRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  }, 100);
  };

 /*const addToCart = (item, quantity = 1, instructions = '') => {
    const validQuantity = isNaN(quantity) ? 1 : quantity;
    const existingItem = Array.isArray(cart) ? cart.find(cartItem => cartItem.id === item.id) : null;
    if (existingItem) {
      setCart(cart.map(cartItem =>
        cartItem.id === item.id
          ? {
            ...cartItem,
            quantity: cartItem.quantity + validQuantity,
            totalPrice: (cartItem.quantity + validQuantity) * item.price,
            cookingInstructions: instructions || cartItem.cookingInstructions || ''
          }
          : cartItem
      ));
    } else {
      setCart([...cart, {
        ...item,
        quantity: validQuantity,
        totalPrice: validQuantity * item.price,
        cookingInstructions: instructions || ''
      }]);
    }
    setCookingInstructions(prev => ({ ...prev, [item.id]: instructions }));
  };*/

  const addToCart = (item, quantity = 1, instructions = '') => {
    if (isViewOnly) return;
  const validQuantity = isNaN(quantity) ? 1 : quantity;

  setCart(prevCart => {
    let updatedCart;

    const existingItem = prevCart.find(cartItem => cartItem.id === item.id);
const price = getItemPrice(item);
    if (existingItem) {
      updatedCart = prevCart.map(cartItem =>
        cartItem.id === item.id
          ? {
              ...cartItem,
              quantity: cartItem.quantity + validQuantity,
              //totalPrice: (cartItem.quantity + validQuantity) * item.price,
              totalPrice: (cartItem.quantity + validQuantity) * price,
              cookingInstructions: instructions || cartItem.cookingInstructions || ''
            }
          : cartItem
      );
    } else {
      updatedCart = [
        ...prevCart,
        {
          ...item,
          itemInstanceId: `${item.id}_${Date.now()}_${Math.random()}`,
          quantity: validQuantity,
          //totalPrice: validQuantity * item.price,
          

totalPrice: validQuantity * price,
price: price,
          cookingInstructions: instructions || ''
        }
      ];
    }

   if (typeof updateCartInFirestore === "function") {
  updateCartInFirestore(updatedCart);
} else {
  console.error("updateCartInFirestore is not available");
}
    return updatedCart;
  });

};
  /*const decreaseQuantity = (item) => {
    const existingItem = Array.isArray(cart) ? cart.find(cartItem => cartItem.id === item.id) : null;
    if (!existingItem) return;

    if (existingItem.quantity === 1) {
      setCart(cart.filter(cartItem => cartItem.id !== item.id));
      setCookingInstructions(prev => {
        const { [item.id]: _, ...rest } = prev;
        return rest;
      });
    } else {
      setCart(cart.map(cartItem =>
        cartItem.id === item.id
          ? {
            ...cartItem,
            quantity: cartItem.quantity - 1,
            totalPrice: (cartItem.quantity - 1) * item.price,
            cookingInstructions: cartItem.cookingInstructions || ''
          }
          : cartItem
      ));
    }
  };*/
  const decreaseQuantity = (item) => {
    if (isViewOnly) return;
  setCart(prevCart => {
    const existingItem = prevCart.find(cartItem => cartItem.id === item.id);
    const price = getItemPrice(item);
    if (!existingItem) return prevCart;

    let updatedCart;

    if (existingItem.quantity === 1) {
      updatedCart = prevCart.filter(cartItem => cartItem.id !== item.id);
    } else {
      updatedCart = prevCart.map(cartItem =>
        cartItem.id === item.id
          ? {
              ...cartItem,
              quantity: cartItem.quantity - 1,
              //totalPrice: (cartItem.quantity - 1) * item.price,
              totalPrice: (cartItem.quantity - 1) * price
            }
          : cartItem
      );
    }

    if (typeof updateCartInFirestore === "function") {
  updateCartInFirestore(updatedCart);
} else {
  console.error("updateCartInFirestore is not available");
}
    return updatedCart;
  });
};
  const handleDetailClick = (item) => {
    setDetailDialog({ open: true, item });
  };

  const handleDetailClose = () => {
    setDetailDialog({ open: false, item: null });
  };

  /*useEffect(() => {
  const handleScroll = () => {
    const scrollTop = window.scrollY;
    const windowHeight = window.innerHeight;
    const docHeight = document.documentElement.scrollHeight;

    // show button when user is near bottom (you can adjust 200)
    if (scrollTop + windowHeight >= docHeight - 200) {
      setShowScrollTop(true);
    } else {
      setShowScrollTop(false);
    }
  };

  window.addEventListener("scroll", handleScroll);
  return () => window.removeEventListener("scroll", handleScroll);
}, []);*/
useEffect(() => {
  const handleScroll = () => {
    setShowScrollTop(window.scrollY > 500);
  };

  window.addEventListener("scroll", handleScroll);
  return () => window.removeEventListener("scroll", handleScroll);
}, []);


const scrollToCategories = () => {
  if (categoriesRef.current) {
    const top = categoriesRef.current.offsetTop - 20; // small padding adjustment

    window.scrollTo({
      top,
      behavior: "smooth",
    });
  }
};

  if (!companyCode || !tableId || !unitCode) {
    return (
      <Container maxWidth="lg" sx={{ py: 3, textAlign: 'center' }}>
        <Typography variant="h5" color="text.secondary">
          Please scan a QR code to view the menu.
        </Typography>
      </Container>
    );
  }

  if (isLoading || isPureVeg === null) {
    return (
      <Container maxWidth="lg" sx={{ py: 3, textAlign: 'center' }}>
        <Typography variant="h5">Loading menu...</Typography>
      </Container>
    );
  }

  if (error) {
    return (
      <Container maxWidth="lg" sx={{ py: 3, textAlign: 'center' }}>
        <Typography variant="h5" color="error">
          {error}
        </Typography>
      </Container>
    );
  }

  //let filteredItems = items;
  const hasSearchQuery = localSearchQuery.trim() !== '';
  /*const vegItems = items.filter(item => item.type === "veg");
  const nonVegItems = isPureVeg ? [] : items.filter(item => item.type === "nonveg");
  const currentItems = isPureVeg ? vegItems : (activeTab === 0 ? vegItems : nonVegItems);

  filteredItems = activeCategory === "All"
    ? currentItems
    : currentItems.filter(item => item.category === activeCategory);*/

   // const currentItems = items;
const activeTimings = getActiveTimings();
const activeSet = new Set(activeTimings);

let filteredItems = items
  .filter(item => {
    if (!item.timing) return false;

    if (item.timing === "All Day") return true;

    return activeSet.has(item.timing);
  })
  .filter(item => {
    return activeCategory === "All"
      ? true
      : item.category === activeCategory;
  });
/*filteredItems =
  activeCategory === "All"
    ? currentItems
    : currentItems.filter(item => item.category === activeCategory);*/

  if (hasSearchQuery) {
    const query = localSearchQuery.toLowerCase().trim();
    filteredItems = filteredItems.filter(item =>
      item.name.toLowerCase().includes(query) ||
      (item.description && item.description.toLowerCase().includes(query))
    );
  }

  return (
    <Container maxWidth="lg" sx={{ py: 3, position: 'relative', transition: 'margin-right 0.3s ease', mr: cartMarginAdjustment }}>
      <Box display="flex" alignItems="center" mb={3}>
        <RestaurantMenuIcon fontSize="large" sx={{ mr: 2 }} />
        <Typography variant="h4">Menu - {companyName || 'Restaurant'}</Typography>
      </Box>

      {/*{!isPureVeg && (
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          variant="fullWidth"
          sx={{ mb: 3 }}
        >
          <Tab label="Vegetarian" />
          <Tab label="Non-Vegetarian" />
        </Tabs>
      )}*/}

      <Box
        /*display="flex"
        justifyContent="center"
        flexWrap="wrap"
        gap={2}
        sx={{ mb: 2 }}*/
         ref={categoriesRef}
         sx={{
    display: "grid",
    gridTemplateColumns: {
      xs: "repeat(4, 1fr)", // 4 per row on mobile
      sm: "repeat(5, 1fr)", // 5 per row on tablet
      md: "repeat(8, 1fr)", // more on desktop
    },
    gap: 2,
    mb: 3,
    justifyItems: "center",
  }}
      >
        {categories.map(category => (
          <Box
            key={category}
            onClick={() => handleCategoryChange(category)}
            sx={{
              cursor: 'pointer',
              boxShadow: activeCategory === category ? '0 0 6px 1px primary.main' : 'none',
              borderRadius: '50%',
              p: 0.25,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              '&:hover': { opacity: 0.7 }
            }}
          >
            <img
              //src={`/images/${category.toLowerCase()}.jpg`}
               src={
    category === "All"
      ? "/images/all.jpg" // optional static
      : categoryImages[category] || "/placeholder.png"
  }
              alt={category}
              style={{ width: '60px', height: '60px', objectFit: 'cover', borderRadius: '50%' }}
              onError={(e) => { e.target.src = '/placeholder.png'; }}
            />
            <Typography
              variant="caption"
              //sx={{ mt: 0.5, fontSize: '0.7rem', textAlign: 'center' }}
              sx={{
    mt: 0.5,
    textAlign: "center",
    fontSize: "0.7rem",
    lineHeight: 1.1,
    // Removed line-clamp and fixed minHeight to let it grow naturally
    wordBreak: "break-word", 
  }}

            >
              {category}
            </Typography>
          </Box>
        ))}
      </Box>

      <Box sx={{ mb: 3, maxWidth: '400px', mx: 'auto' }}>
        <TextField
          fullWidth
          variant="outlined"
          size="small"
          placeholder={`Search within ${activeCategory}`}
          value={localSearchQuery}
          onChange={(e) => setLocalSearchQuery(e.target.value)}
          sx={{
            '& .MuiOutlinedInput-root': {
              borderRadius: '20px',
              bgcolor: 'background.paper',
            },
            '& .MuiInputBase-input': {
              py: 1.5,
            },
          }}
        />
      </Box>

      {filteredItems.length === 0 ? (
        <Box display="flex" justifyContent="center" alignItems="center" height="200px" border="2px dashed #ccc" borderRadius={2}>
          <Typography variant="h6" color="text.secondary">
            {hasSearchQuery
              ? `No items found for "${localSearchQuery}" in ${activeCategory}.`
              /*: `No items in ${activeCategory}${isPureVeg ? "" : ` for ${activeTab === 0 ? "Vegetarian" : "Non-Vegetarian"}`}.`}*/
              : `No items in ${activeCategory}.`}
          </Typography>
        </Box>
      ) : (
        <Box mb={4} ref={menuItemsRef}>
          <Typography variant="h5" mb={2}>
            {hasSearchQuery ? `Search Results for "${localSearchQuery}" in ${activeCategory}` : activeCategory}
          </Typography>
          <Divider sx={{ mb: 2 }} />
          <Grid container spacing={2}>
            {filteredItems.map((item) => {
              const cartItem = Array.isArray(cart) ? cart.find(cartItem => cartItem.id === item.id) : null;
              const itemQuantity = cartItem ? cartItem.quantity : 0;
              const instructions = cookingInstructions[item.id] || '';

              return (
                <Grid item xs={12} sm={6} md={4} key={item.id}>
                  <Card
                    elevation={3}
                    sx={{
                      height: '340px',
                      width: '250px',
                      display: 'flex',
                      flexDirection: 'column',
                      cursor: 'pointer',
                      margin: '8px'
                    }}
                    onClick={(e) => {
                      if (!e.target.closest('.MuiButtonBase-root') && !e.target.closest('.MuiInputBase-root')) {
                        handleDetailClick(item);
                      }
                    }}
                  >
                    <CardMedia
                      component="img"
                      height="120"
                      image={item.imageUrl || "/placeholder.png"}
                      alt={item.name}
                      sx={{ objectFit: "cover" }}
                    />
                    <CardContent sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', justifyContent: 'space-between', p: 1 }}>
                      <Box>
                        <Box display="flex" justifyContent="space-between" alignItems="center">
                          <Typography
                            variant="h6"
                            sx={{
                              fontSize: '1rem',
                              textOverflow: 'ellipsis',
                              overflow: 'hidden',
                              whiteSpace: 'nowrap',
                              maxWidth: '150px'
                            }}
                          >
                            {item.name}
                          </Typography>
                          <Typography
                            variant="caption"
                            sx={{
                              bgcolor: item.type === "veg" ? "success.light" : "error.light",
                              width: '72px',
                              px: 1,
                              py: 0.5,
                              borderRadius: 1,
                              color: "white",
                              textAlign: 'center',
                              fontSize: '0.75rem'
                            }}
                          >
                            {item.type === "veg" ? "VEG" : "NON-VEG"}
                          </Typography>
                        </Box>
                        <Typography
                          variant="body2"
                          color="text.secondary"
                          sx={{
                            fontSize: '0.75rem',
                            mt: 0.5,
                            display: '-webkit-box',
                            WebkitLineClamp: 4,
                            WebkitBoxOrient: 'vertical',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis'
                          }}
                        >
                          {item.description || "No description available"}
                        </Typography>
                      </Box>
                      <Box>
                        <Box sx={{ mt: 1 }}>
                          <Rating
                            value={item.averageRating || 4}
                            precision={0.5}
                            readOnly
                            size="small"
                          />
                        </Box>
                        <Box display="flex" alignItems="center" justifyContent="space-between">
                          <Typography variant="h6" color="text.secondary" sx={{ fontSize: '1rem' }}>
                            ₹{/*{item.price}*/} {getItemPrice(item).toFixed(2)}
                          </Typography>
                          {item.available ? (
                            <Box display="flex" alignItems="center">
                              {itemQuantity === 0 ? (
                                <Button
                                  variant="contained"
                                  color="primary"
                                  size="small"
                                  sx={{ fontSize: '0.75rem', padding: '4px 8px' }}
                                   disabled={isViewOnly}
                                  //onClick={() => addToCart(item, 1, '')}
                                   onClick={() => {
    addToCart(item, 1, '');
 if (typeof toggleCartDrawer === 'function') {
    toggleCartDrawer(true);
  }
  }}
                                >
                                  Add
                                </Button>
                              ) : (
                                <Box display="flex" alignItems="center" gap={1}>
                                  <IconButton
                                    size="small"
                                    color="primary"
                                    disabled={isViewOnly}
                                    onClick={() => decreaseQuantity(item)}
                                    sx={{ p: 0.5 }}
                                  >
                                    <RemoveIcon fontSize="small" />
                                  </IconButton>
                                  <Typography sx={{ fontSize: '0.9rem', fontWeight: 'bold' }}>
                                    {itemQuantity}
                                  </Typography>
                                  <IconButton
                                    size="small"
                                    color="primary"
                                     disabled={isViewOnly}
                                    onClick={() => addToCart(item, 1, instructions)}
                                    sx={{ p: 0.5 }}
                                  >
                                    <AddIcon fontSize="small" />
                                  </IconButton>
                                </Box>
                              )}
                            </Box>
                          ) : (
                            <Typography variant="body2" color="error" sx={{ fontSize: '0.75rem', fontStyle: 'italic' }}>
                              Unavailable
                            </Typography>
                          )}
                        </Box>
                        {item.available && itemQuantity > 0 && (
                          <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            disabled={isViewOnly}
                            placeholder="Cooking instructions"
                            value={instructions}
                            /*onChange={(e) => {
                              setCookingInstructions(prev => ({
                                ...prev,
                                [item.id]: e.target.value
                              }));
                              setCart(cart.map(cartItem =>
                                cartItem.id === item.id
                                  ? { ...cartItem, cookingInstructions: e.target.value }
                                  : cartItem
                              ));
                            }}*/
                           onChange={(e) => {
  const value = e.target.value;

  setCookingInstructions(prev => ({
    ...prev,
    [item.id]: value
  }));

  setCart(prevCart => {
  const updatedCart = prevCart.map(cartItem =>
    cartItem.id === item.id
      ? { ...cartItem, cookingInstructions: value }
      : cartItem
  );

  updateCartInFirestore(updatedCart);
  return updatedCart;
});
}}
                            sx={{ mt: 1 }}
                          />
                        )}
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>
              );
            })}
          </Grid>
        </Box>
      )}

      <Cart
        cart={cart}
        setCart={setCart}
        openCartDrawer={openCartDrawer}
        //openCartDrawer={openCartDrawerFromParent}
        //toggleCartDrawer={toggleCartDrawer}
        //toggleCartDrawer={() => setOpenCartDrawer(false)}
        //openCartDrawer={openCartDrawer}
          toggleCartDrawer={toggleCartDrawer}
        isMobile={isMobile}
        navigate={navigate}
        setCartMarginAdjustment={setCartMarginAdjustment}
        companyCode={companyCode}
        companyName={companyName}
        tableId={tableId}
        unitCode={unitCode}
        cartId={cartId} 
        serviceArea={serviceArea}
        updateCartInFirestore={updateCartInFirestore}
      />

      <Dialog open={detailDialog.open} onClose={handleDetailClose} maxWidth="md" fullWidth>
        <DialogTitle>
          <Box display="flex" alignItems="center" justifyContent="space-between" gap={1}>
            <Typography variant="h5">{detailDialog.item?.name}</Typography>
            <Typography
              variant="caption"
              sx={{
                bgcolor: detailDialog.item?.type === "veg" ? "success.light" : "error.light",
                width: '72px',
                px: 1,
                py: 0.5,
                borderRadius: 1,
                color: "white",
                textAlign: 'center',
                fontSize: '0.75rem'
              }}
            >
              {detailDialog.item?.type === "veg" ? "VEG" : "NON-VEG"}
            </Typography>
          </Box>
        </DialogTitle>
        <DialogContent>
          <Box display="flex" flexDirection={{ xs: 'column', sm: 'row' }} gap={2}>
            <Box flexShrink={0}>
              <CardMedia
                component="img"
                height="200"
                sx={{ width: 300, objectFit: "cover", borderRadius: 1 }}
                image={detailDialog.item?.imageUrl || "/placeholder.png"}
                alt={detailDialog.item?.name}
              />
            </Box>
            <Box>
              <Typography variant="body1" sx={{ fontSize: '0.9rem', mb: 1 }}>
                {detailDialog.item?.description || "No description available"}
              </Typography>
              {detailDialog.item?.ingredients && (
                <Typography variant="body1" sx={{ fontSize: '0.9rem', mb: 1 }}>
                  <em>Ingredients:</em> {detailDialog.item?.ingredients}
                </Typography>
              )}
              <Box sx={{ mt: 1, mb: 2 }}>
                <Rating
                  value={detailDialog.item?.averageRating || 4}
                  precision={0.5}
                  readOnly
                  size="medium"
                />
              </Box>
              {detailDialog.item?.available && (
                <Box display="flex" flexDirection="column" mt={2}>
                  {(() => {
                    const cartItem = Array.isArray(cart) ? cart.find(cartItem => cartItem.id === detailDialog.item?.id) : null;
                    const itemQuantity = cartItem?.quantity || 0;
                    const instructions = cookingInstructions[detailDialog.item?.id] || cartItem?.cookingInstructions || '';
                    return (
                      <>
                        <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
                          <Typography variant="h6" color="text.secondary" sx={{ fontSize: '1.25rem' }}>
                            ₹{/*{detailDialog.item?.price}*/}{(getItemPrice(detailDialog.item)).toFixed(2)}
                          </Typography>
                          <Box display="flex" alignItems="center">
                            {itemQuantity === 0 ? (
                              <Button
                                variant="contained"
                                color="primary"
                                size="small"
                                sx={{ fontSize: '0.75rem', padding: '4px 8px' }}
                                disabled={isViewOnly}
                                onClick={() => addToCart(detailDialog.item, 1, '')}
                              >
                                Add
                              </Button>
                            ) : (
                              <Box display="flex" alignItems="center" gap={1}>
                                <IconButton
                                  size="small"
                                  color="primary"
                                  disabled={isViewOnly}
                                  onClick={() => decreaseQuantity(detailDialog.item)}
                                  sx={{ p: 0.5 }}
                                >
                                  <RemoveIcon fontSize="small" />
                                </IconButton>
                                <Typography sx={{ fontSize: '0.9rem', fontWeight: 'bold' }}>
                                  {itemQuantity}
                                </Typography>
                                <IconButton
                                  size="small"
                                  color="primary"
                                   disabled={isViewOnly}
                                  onClick={() => addToCart(detailDialog.item, 1, instructions)}
                                  sx={{ p: 0.5 }}
                                >
                                  <AddIcon fontSize="small" />
                                </IconButton>
                              </Box>
                            )}
                          </Box>
                        </Box>
                        {itemQuantity > 0 && (
                          <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            placeholder="Cooking instructions"
                            value={instructions}
                             disabled={isViewOnly}
                            onChange={(e) => {
                              setCookingInstructions(prev => ({
                                ...prev,
                                [detailDialog.item?.id]: e.target.value
                              }));
                              setCart(cart.map(cartItem =>
                                cartItem.id === detailDialog.item?.id
                                  ? { ...cartItem, cookingInstructions: e.target.value }
                                  : cartItem
                              ));
                            }}
                            sx={{ mt: 1 }}
                          />
                        )}
                      </>
                    );
                  })()}
                </Box>
              )}
              <Typography
                variant="body1"
                color={detailDialog.item?.type === "veg" ? "success.main" : "error.main"}
                sx={{ fontSize: '0.9rem', mb: 1, mt: detailDialog.item?.available ? 0 : 2 }}
              >
                {detailDialog.item?.available ? "Available" : "Currently unavailable"}
              </Typography>
            </Box>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDetailClose} sx={{ fontSize: '0.9rem' }}>Close</Button>
        </DialogActions>
      </Dialog>
      {showScrollTop && (
  <IconButton
    onClick={scrollToCategories}
    sx={{
      position: "fixed",
      bottom: 90,
      right: 20,
      bgcolor: "primary.main",
      color: "white",
      "&:hover": { bgcolor: "primary.dark" },
      boxShadow: 3,
      zIndex: 9999,
    }}
  >
    <KeyboardArrowUpIcon />
  </IconButton>
)}
    </Container>
  );
}